import { Space } from 'antd';

interface AuthFormWrapperProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

export const AuthFormWrapper = ({
  children,
  title,
  subtitle,
}: AuthFormWrapperProps) => {
  return (
    <div className="flex justify-center">
      <div className="relative md:w-[310px] w-full">
        <div className="flex flex-col items-center">
          <div className="relative">
            <h1 className="capitalize text-primary text-3xl py-2">{title}</h1>
            <Space className="my-8" />
            <div className="capitalize text-[14px] text-primary">
              {subtitle}
            </div>

            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
